import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IDeleteState, IResponse } from '../../types'

const sharedApiClient = AdminApiClient.getInstance()

export const fetchDeleteInvoice = createAsyncThunk(
  'listInvoices/fetchDeleteInvoice',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await sharedApiClient.deleteInvoice(id)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IDeleteState = {
  isLoading: false,
  response: null,
  error: null
}

const deleteInvoiceSlice = createSlice({
  name: 'invoices/delete',
  initialState,
  reducers: {
    resetDeleteInvoice: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchDeleteInvoice.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchDeleteInvoice.fulfilled, (state, action: PayloadAction<IResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchDeleteInvoice.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default deleteInvoiceSlice.reducer
export const { resetDeleteInvoice } = deleteInvoiceSlice.actions
